import { Monitor, Moon, Sun } from 'lucide-react';
import type { LucideIcon } from 'lucide-react';
import type { ThemePreference, UseThemePreferenceState } from './hooks/useThemePreference';

const OPTIONS: ReadonlyArray<{
    value: ThemePreference;
    label: string;
    Icon: LucideIcon;
}> = [
    { value: 'system', label: 'System', Icon: Monitor },
    { value: 'light',  label: 'Light',  Icon: Sun },
    { value: 'dark',   label: 'Dark',   Icon: Moon },
];

export function ThemeModeControl({ hook }: { hook: UseThemePreferenceState }) {
    return (
        <div className="card">
            <div className="flex items-start justify-between gap-3">
                <div>
                    <h3 className="font-semibold mb-1">Theme</h3>
                    <p className="muted text-sm">
                        Match your phone or pick a fixed mode.
                    </p>
                </div>
                <span className="rounded-full bg-surface-raised px-2 py-1 text-xs font-medium text-muted">
                    {hook.loading ? 'Loading' : hook.effectiveTheme}
                </span>
            </div>
            <div className="mt-4 grid grid-cols-3 gap-2 rounded-xl border border-line bg-surface-raised p-1">
                {OPTIONS.map(({ value, label, Icon }) => {
                    const selected = hook.preference === value;
                    return (
                        <button
                            key={value}
                            type="button"
                            className={`flex items-center justify-center gap-1.5 rounded-lg px-2 py-2 text-sm font-semibold transition ${
                                selected
                                    ? 'bg-brand text-on-brand shadow-sm'
                                    : 'text-muted hover:bg-surface hover:text-text'
                            }`}
                            aria-pressed={selected}
                            onClick={() => { void hook.setPreference(value); }}
                        >
                            <Icon className="h-4 w-4" aria-hidden strokeWidth={2.2} />
                            <span>{label}</span>
                        </button>
                    );
                })}
            </div>
        </div>
    );
}
